import { LogErrors } from './../../LogErrors'

import { GetOtherGroupsByInstructor as DLGetOtherGroupsByInstructor, MoveZtudentBetweenGroups as DLMoveZtudentBetweenGroups } from './../../DL/Instructor/ChangeGroup'


const GetOtherGroupsByInstructor = async (groupSelected) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
          return { success: false, message: '' }
        }

        const idRole = userData?.navigation?.role?.id
        if (!idRole) {
          return { success: false, message: '' }
        }

        if (!groupSelected) {
          return { success: false, message: '' }
        }

        const token = userData?.token
        if (!token) {
          return { success: false, message: '' }
        }

        const response = await DLGetOtherGroupsByInstructor(idCenter, idRole, groupSelected, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetOtherGroupsByInstructor ChangeGroup BL', error)
    }
}

const MoveZtudentBetweenGroups = async (ztudentSelected, groupFromSelected, groupToSelected) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter) {
          return { success: false, message: '' }
        }

        const idRole = userData?.navigation?.role?.id
        if (!idRole) {
          return { success: false, message: '' }
        }

        if (!ztudentSelected) {
            return { success: false, message: '' }
        }

        if (!groupFromSelected) {
            return { success: false, message: '' }
        }

        if (!groupToSelected) {
            return { success: false, message: '' }
        }

        const token = userData?.token
        if (!token) {
          return { success: false, message: '' }
        }

        const response = await DLMoveZtudentBetweenGroups(idCenter, idRole, ztudentSelected, groupFromSelected, groupToSelected, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('MoveZtudentBetweenGroups ChangeGroup BL', error)
    }
}

export { GetOtherGroupsByInstructor, MoveZtudentBetweenGroups };